import * as React from "react";
import {createRef} from "react";
import Slider from "react-slick";
/* Slider zum Wechseln der Seiten */
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./customer-portal-login.css";
import {ErlButtonBigRed} from "./ErlButtonBigRed";
import {EmailInput} from "./EmailInput";
import {AccountService} from "../service/AccountService";
import {PasswordInput} from "./PasswordInput";
import {getMessageText, InputFieldState} from "../../shared/helpers/InputFieldState";
import {CheckBox} from "./CheckBox";
import {AppService} from "../../shared/services/AppService";
import {Document, getLegalDocument, LegalDocumentType} from "../../shared/models/Document";
import {getErrorMessagesFromResponse} from "../../shared/models/ApiResponse";
import {AppContext} from "../context/AppContext";
import {LoaderSpinner} from "./LoaderSpinner";

interface CustomerPortalLoginProps {
    config: {
        baseUrl: string,
        agId?: string
    }
}

interface CustomerPortalLoginState {
    email: InputFieldState,
    password: InputFieldState,
    termsOfUse: InputFieldState,
    sending: boolean,
    accountExist: boolean,
    termsOfUseDocument: Document,
    error: boolean,
    newsletterCustomerPortal: InputFieldState
}

/**
 * Text Input Element
 */
export class CustomerPortalLogin extends React.Component<CustomerPortalLoginProps, CustomerPortalLoginState> {
    slider: Slider;

    accountService: AccountService;
    appService: AppService;

    readonly emailInput = createRef<EmailInput>();

    state: CustomerPortalLoginState = {
        email: {value: ''},
        password: {value: ''},
        termsOfUse: {value: '', isChecked: false},
        sending: true,
        accountExist: false,
        termsOfUseDocument: null,
        error: false,
        newsletterCustomerPortal: {value: '', isChecked: false, required: false},
    }

    constructor(props: CustomerPortalLoginProps) {
        super(props);
        this.accountService = new AccountService(AppContext.dataStore);
        this.appService = new AppService(AppContext.dataStore, '/wp-json/kundenportal');

        this.appService.getLegalDocuments().then((legalDocuments: Document[]) => {
            this.setState({
                sending: false,
                termsOfUseDocument: getLegalDocument(legalDocuments, LegalDocumentType.TermsOfUse)
            });
        }).catch(console.warn);
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        if (code && !AppContext.dataStore.retrieveData('affiliateCode')) {
            AppContext.dataStore.storeData('affiliateCode', code);
        }
    }

    openCustomerPortal() {
        window.open(this.props.config.baseUrl, '');
    }

    getRedirectUrl() {
        return '/kundenportal';
    }

    isEmail(email: string) {
        var re = /\S+@\S+\.\S\S+/;
        return re.test(email);
    }

    /**
     * check invest account exist. yes weed ned a password.
     */
    checkAccount() {
        if (this.state.sending || !this.isEmail(this.state.email.value.toString())) return;

        this.setState({...this.state, sending: true, accountExist: false}, () => {
            // check invest account exist. yes => do passwort login. no => normal login
            this.accountService.checkAccountExist(this.state.email.value.toString()).then(resp => {
                if (resp.response.accountExist) {
                    // password needed
                    this.setState({...this.state, accountExist: true, sending: false});
                } else {
                    this.setState({...this.state, sending: false, accountExist: false}, () => {
                        console.log('account not exists');
                        if (this.state.termsOfUse.isChecked) {
                            this.submitEmail();
                        }
                    });
                }
            }).catch(reason => {
                //Account not exists
                console.warn(reason);
                this.setState({...this.state, sending: false, accountExist: false}, () => {
                    if (this.state.termsOfUse.isChecked) {
                        this.createAccount();
                    }
                });
                console.log('create account true');
            });
        });

    }

    submitEmail() {
        if (this.state.sending || !this.isEmail(this.state.email.value.toString())) return;
        this.setState({...this.state, sending: true}, () => {
            this.accountService.requestLogin(this.state.email.value.toString(), this.state.password.value.toString(), this.getRedirectUrl())
                .then((response) => {
                    this.setState({
                        ...this.state,
                        sending: false
                    }, () => {
                        this.emailInput.current.blur();
                        if (!response.success || (response.response && response.response.createAccount)) {
                            this.createAccount();
                        } else if (response.response?.url) {
                            const win = window.open();
                            win.location.href = response.response.url;
                        } else {
                            this.slider.slickNext();
                        }
                    });
                }).catch(reason => {
                if (reason.response && reason.response.errorMessage && reason.response.errorMessage.invalid) {
                    this.setState({
                        ...this.state,
                        email: {
                            value: this.state.password.value,
                            errorMessage: 'Benutzer/Passwort Kombination nicht korrekt'
                        },
                        sending: false
                    });
                } else {
                    const messageText = getMessageText(getErrorMessagesFromResponse(reason));
                    this.setState({
                        ...this.state,
                        email: {
                            value: this.state.email.value,
                            errorMessage: messageText ?? 'Es ist ein unerwarteter Fehler aufgetreten'
                        },
                        sending: false
                    });
                }
                console.warn(reason);
            });
        });
    }

    createAccount() {
        if (this.state.sending) return;

        this.setState({...this.state, sending: true, error: false}, () => {
            this.accountService.requestCreateAccount(
                this.state.email.value.toString(),
                this.state.termsOfUse.isChecked,
                this.state.newsletterCustomerPortal.isChecked,
                this.getRedirectUrl(),
                this.props.config.agId
            ).then(() => {
                this.slider.slickNext();
                this.setState({...this.state, sending: false});
                AppContext.googleTracking.track('immobilienkonto-signup', 'done');
            }).catch(reason => {
                console.log(reason);
                this.setState({...this.state, sending: false, error: true});
            });
        });
    }

    render() {

        //Slider konfigurieren
        const sliderSettings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            touchMove: false,
        };

        return <div className={"customer-portal-login invest"}>
            <div onClick={() => this.slider.slickGoTo(0)} className="customer-portal-header">
                <img alt={"Mein ERL"} src={"/wp-content/plugins/erlbau/images/customer-portal/logoMeinERL.svg"}/>
            </div>
            <Slider ref={slider => (this.slider = slider)} {...sliderSettings}>
                <div className="login-slide">
                    <div className="login-slide-container">
                        <p>Jetzt Zugang zu Mein ERL erhalten und mehr übers Immobilienkonto erfahren.</p>
                    </div>

                    <div className="login-slide-container">

                        <EmailInput editable={!this.state.accountExist} ref={this.emailInput} autofocus={false}
                                    onChange={(value) => {
                                        this.setState({...this.state, email: {value: value}});
                                    }} onEnter={() => this.checkAccount()} label={""} placeholder={"E-Mail"}
                                    state={this.state.email}/>

                        {this.state.accountExist ? (
                            <React.Fragment>
                                <PasswordInput label={""} placeholder={"Passwort"} state={this.state.password}
                                               onEnter={() => this.submitEmail()}
                                               onChange={value => {
                                                   this.setState({...this.state, password: {value: value}});
                                               }}/>

                                <div className={"to-bottom"}>
                                    <div>
                                        <ErlButtonBigRed disabled={!this.isEmail(this.state.email.value.toString())}
                                                         label={"Los geht's!"}
                                                         className={"width-50 submit login"}
                                                         onclick={() => this.submitEmail()}/>
                                    </div>
                                    <div>
                                        <ErlButtonBigRed disabled={!this.isEmail(this.state.email.value.toString())}
                                                         className={"width-50 password-forget"}
                                                         label={"Passwort vergessen"}
                                                         onclick={() => window.open(this.props.config.baseUrl + '/account/login/reset/' + encodeURIComponent(this.state.email.value as string))}/>
                                    </div>
                                </div>
                            </React.Fragment>
                        ) : (
                            <>
                                {!this.state.sending ? (
                                    <>
                                        <div className={"line-height-1-3"}>
                                            <CheckBox state={this.state.termsOfUse} onChange={(value, newState) => {
                                                this.setState({
                                                    ...this.state,
                                                    termsOfUse: {value: value, isChecked: newState}
                                                });
                                            }} label={""}>
                                                Ich stimme den <a target="_blank"
                                                                  href={this.state.termsOfUseDocument?.fullPath ?? 'about:blank'}>Nutzungsbedingungen</a> und
                                                der <a target="_blank"
                                                       href="https://www.erl.de/datenschutz/">Datenschutzerklärung</a> zu.
                                            </CheckBox>
                                            <CheckBox state={this.state.newsletterCustomerPortal}
                                                      onChange={(value, newState) => {
                                                          this.setState({
                                                              ...this.state,
                                                              newsletterCustomerPortal: {
                                                                  value: value,
                                                                  isChecked: newState
                                                              }
                                                          });
                                                      }} label={""}>
                                                Ich möchte den Newsletter zum Immobilienkonto abonnieren.
                                            </CheckBox>
                                            <div className={"customer-portal-newsletter"}>
                                                <p>
                                                    Die Einwilligung ist freiwillig und kann jederzeit widerrufen
                                                    werden. Der Widerruf erfolgt entweder in den Profileinstellungen,
                                                    durch einen Abbestellwunsch an die auf der Website genannte
                                                    Kontaktadresse oder durch einen Klick auf den Abbestelllink in den
                                                    zugesandten Nachrichten.
                                                </p>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <LoaderSpinner/>
                                )}
                                {this.state.error && (
                                    <p className={"error_message"}>
                                        Es ist ein unerwarteter Fehler aufgetreten
                                    </p>
                                )}
                                <div className={"to-bottom"}>
                                    <ErlButtonBigRed
                                        label={"Los geht's!"}
                                        disabled={!this.isEmail(this.state.email.value.toString()) || !this.state.termsOfUse.isChecked}
                                        className={"submit login"} onclick={() => {
                                        if (this.state.sending) return;
                                        this.setState({...this.state, sending: true}, () => {
                                            this.accountService.isLoggedIn().then((isLoggedIn) => {
                                                this.setState({...this.state, sending: false}, () => {
                                                    if (isLoggedIn) {
                                                        this.openCustomerPortal();
                                                    } else {
                                                        this.checkAccount();
                                                    }
                                                });
                                            });
                                        });
                                    }}/>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="login-slide">
                    <div className="login-slide-container">
                        <img className={"ok"} alt={"Mein ERL"}
                             src="/wp-content/plugins/erlbau/images/customer-portal/ok.png"/>
                    </div>
                    <div className="login-slide-container">
                        <p>Prüfen Sie Ihren Posteingang und los geht's.</p>
                    </div>
                    <div className="login-slide-container">
                        <a className="small to-bottom" onClick={() => this.slider.slickGoTo(0)}>E-Mail erneut
                            versenden</a>
                    </div>
                </div>
            </Slider>
            <div className={"customer-portal-footer"}>
                <p>
                    Die ERL Immovermittlung GmbH handelt als vertraglich gebundener Vermittler im Sinne des § 3
                    Abs. 2 Satz 1 Wertpapierinstitutsgesetz (WpIG) ausschließlich für Rechnung und unter der Haftung der
                    CM-Equity AG, soweit sie Dienstleistungen erbringt, die der Anlagevermittlung im Sinne des § 2 Abs.
                    2 Nr. 3 WpIG zuzurechnen sind. <br/>
                    <a href={"https://portal.mvp.bafin.de/database/VGVInfo/vermittler.do?cmd=unternehmenZuVermittlerAction&id=-160353276"}
                       target={"_blank"}>Eintrag im Bafin-Register</a>
                </p>
            </div>
        </div>
    }
}
